import { IMAGE_URL } from "../../path";

interface ImageTextProps {
    id: number;
    image_first: boolean;
    body_copy: string;
    image_path: string;
    title?: string;
    date_posted?: string;
}

function CustomImageTextComponent(props: ImageTextProps) {
    const formattedBodyCopy = props.body_copy.replace(
        /<p>/g,
        '<p class="text-inner">'
    );

    return (
        <div
            className={`image-text-component ${props.image_first ? "image-first" : "text-first"}`}
            key={props.id}
        >
            <div className="image-text-wrapper">
                {props.image_first ? (
                    <>
                        <div className="image-text-image">
                            <img src={IMAGE_URL + props.image_path} alt={props.image_path} />
                        </div>
                        <div className="image-text-body">
                            <div className="inner-text-wrapper">
                                {(props.title || props.date_posted) && (
                                    <div className="body-header">
                                        {props.title && <div className="body-title">{props.title}</div>}
                                        {props.date_posted && <div className="body-date">{props.date_posted}</div>}
                                    </div>
                                )}
                                <div dangerouslySetInnerHTML={{ __html: formattedBodyCopy }} />
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="image-text-body">
                            <div className="inner-text-wrapper">
                                {(props.title || props.date_posted) && (
                                    <div className="body-header">
                                        {props.title && <div className="body-title">{props.title}</div>}
                                        {props.date_posted && <div className="body-date">{props.date_posted}</div>}
                                    </div>
                                )}
                                <div dangerouslySetInnerHTML={{ __html: formattedBodyCopy }} />
                            </div>
                        </div>
                        <div className="image-text-image">
                            <img src={IMAGE_URL + props.image_path} alt={props.image_path} />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default CustomImageTextComponent;
